<template>
  <material-content :type="type" :title="title" />
</template>

<script>
import { MATERIALS_TYPES } from '@/enums/MaterialsTypes';
import MaterialContent from './UIComponents/MaterialContent.vue';

export default {
  components: {
    MaterialContent,
  },
  data() {
    return {
      type: MATERIALS_TYPES.printer.value,
      title: 'Liste des imprimantes',
    };
  },
};
</script>
